import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['errorMessage'];

  validateFields(event) {
    const groups = this.element.querySelectorAll('[data-group]');
    const errors = [];

    groups.forEach((group) => {
      const inputs = group.querySelectorAll('[data-input]');
      const hasValue = Array.from(inputs).some((input) => input.value.trim() !== '');

      if (hasValue && !this.validateGroup(inputs)) {
        const errorMessage = group.getAttribute('data-error-message');
        errors.push({ group, errorMessage });
      }
    });

    if (errors.length > 0) {
      event.preventDefault();
      this.displayErrors(errors);
    } else {
      this.clearErrors();
    }
  }

  validateGroup(inputs) {
    return Array.from(inputs).every((input) => input.value.trim() !== '');
  }

  displayErrors(errors) {
    this.clearErrors();

    errors.forEach((error) => {
      const { group, errorMessage } = error;
      const errorTarget = group.getAttribute('data-error-target');
      const errorContainer = this.element.querySelector(`[data-group-error="${errorTarget}"]`);

      errorContainer.textContent = errorMessage;
    });
  }

  clearErrors() {
    const errorContainers = this.element.querySelectorAll('[data-group-error]');

    errorContainers.forEach((container) => {
      container.textContent = '';
    });
  }

  connect() {
    this.element.addEventListener('submit', this.validateFields.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('submit', this.validateFields.bind(this));
  }
}
